import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { Component } from 'react';
import { colorWithOpacityToHex } from '../../../../utils/color';
export var Segment = /*#__PURE__*/function (_Component) {
  _inherits(Segment, _Component);

  var _super = _createSuper(Segment);

  function Segment() {
    _classCallCheck(this, Segment);

    return _super.apply(this, arguments);
  }

  _createClass(Segment, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("g", {
        onMouseEnter: function onMouseEnter() {
          return _this.props.onHover(_this.props.data.ids);
        },
        onMouseLeave: this.props.onLeave,
        onClick: function onClick() {
          return _this.props.isSelected ? _this.props.onRemove(_this.props.data.ids) : _this.props.onSelect(_this.props.data.ids);
        }
      }, this.renderParts());
    }
  }, {
    key: "renderParts",
    value: function renderParts() {
      var _this2 = this;

      var _this$props = this.props,
          parts = _this$props.data.parts,
          stationsUnderConstruction = _this$props.stationsUnderConstruction;
      return parts.map(function (part, i) {
        return /*#__PURE__*/React.createElement("g", {
          key: i,
          stroke: part.ids && part.ids.filter(function (i) {
            return stationsUnderConstruction.indexOf(i) !== -1;
          }).length > 0 ? colorWithOpacityToHex(_this2.props.lineColor, 0.5) : undefined // eslint-disable-next-line react/no-danger
          ,
          dangerouslySetInnerHTML: {
            __html: part.html
          }
        });
      });
    }
  }]);

  return Segment;
}(Component);